/**
 * contactInformation Service
 */
angular.module('elogbooksServices').service('contactInformationService', function () {
    this.processContactInformation = processContactInformation;
    this.sortFieldsByType = sortFieldsByType;

    /**
     * process the contact information
     *
     * @param {object} data - Data
     * @returns object
     */
    function processContactInformation(data) {
        var contactInformation = {
            fields: [],
            addresses: [],
        };

        if (data.address) {
            contactInformation.addresses.push(data.address);
        }

        if (data.email) {
            contactInformation.fields.push({
                type: 'email',
                value: data.email,
            });
        }

        contactInformation.fields = sortFieldsByType(contactInformation.fields);

        return contactInformation;
    }

    function sortFieldsByType(fields) {
        if (!fields || !fields.length) {
            return [];
        }

        return fields
            .map(function (field, index) {
                return { field: field, index: index };
            })
            .sort(function (a, b) {
                if (a.field.type < b.field.type) {
                    return -1;
                }
                if (a.field.type > b.field.type) {
                    return 1;
                }
                return a.index - b.index;
            })
            .map(function (entry) {
                return entry.field;
            });
    }
});
